import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CircularProgress from 'material-ui/CircularProgress';

import { getUserList, getUserLimitationsList } from 'actions/users';

import styles from 'styles/index';

import Table from './Table';

class BlackAndWhiteListsPage extends React.Component {
    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        this.props.getUserLimitationsList();
        this.props.getUserList({ page: 1 });
    }

    render() {
        return (
            <div id='users-ban' className='container'>
                <CircularProgress
                    className={!this.props.isLoaded ? '' : 'hidden'}
                    style={styles.circularProgress}
                />

                <div className={this.props.isLoaded ? '' : 'hidden'}>
                    <div className='container'>
                        <h2>
                            Black And White Lists
                        </h2>
                    </div>

                    <Table />
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => {
        return {
            isLogged: state.user.isLogged,
            isLoaded: state.users.isLoaded,
        };
    },
    dispatch => bindActionCreators({
        getUserList,
            getUserLimitationsList,
    },
    dispatch),
)(BlackAndWhiteListsPage);



// WEBPACK FOOTER //
// ./app/components/Users/BlackAndWhiteLists/Page.jsx